import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dropbox_active",
  "use": "dropbox_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"dropbox_active\"><path fill-rule=\"evenodd\" d=\"M19 4.485 13.705 1 10 4.117l5.339 3.323L19 4.485Zm-8.99 6.948-3.715 3.108-1.59-1.046v1.173l5.306 3.207 5.306-3.207v-1.173l-1.59 1.046-3.716-3.108ZM6.296 1 1 4.485 4.661 7.44l5.34-3.323L6.294 1ZM10 10.762 6.295 13.88 1 10.395 4.661 7.44 10 10.762l5.339-3.323 3.66 2.956-5.294 3.485L10 10.762Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol